import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryHr } from "./baseQuery";
import { API } from "./constant";

export const employeeFloatApi = createApi({
  baseQuery: baseQueryHr,
  reducerPath: "employeeFloatApi",
  tagTypes: ["float"],
  endpoints: (builder) => ({
    createEmployeeFloat: builder.mutation({
      query: (data) => ({
        url: `${API.EMPLOYEE.CREATE_FLOAT_REQUEST}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["float"],
    }),
    getEmployeeFloatDashboard: builder.query({
      query: ({ year }) => ({
        url: `${API.EMPLOYEE.EMPLOYEE_FLOAT_DASHBOARD}?year=${year}`,
        method: "GET",
      }),
    }),
    getAllloatRequests: builder.query({
      query: ({
        pageSize,
        pageNumber,
        searchText,
        filter,
        startDate,
        endDate,
        RequestorId,
      }) => ({
        url: `${API.EMPLOYEE.GET_ALL_FLOAT_REQUESTS}?PageSize=${pageSize || ""}&PageNumber=${pageNumber || ""}&SearchText=${searchText || ""}&Status=${filter || ""}&StartDate=${startDate || ""}&EndDate=${endDate || ""}&RequestorId=${RequestorId || ""}`,
        method: "GET",
      }),
      providesTags: ["float"],
    }),
    getFloatRequestById: builder.query({
      query: (id) => ({
        url: `${API.EMPLOYEE.GET_FLOAT_BY_ID}?Id=${id}`,
      })
    }),
    updateFloatRequest: builder.mutation({
      query: (data) => ({
        url: `${API.EMPLOYEE.UPDATE_FLOAT_REQUEST}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["float"],
    }),
    approveFloatMgt: builder.mutation({
     query: (data) => ({
        url: `${API.EMPLOYEE.APPROVE_MGT_FLOAT}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["float"],
    }),
    declineFloatMgt: builder.mutation({
     query: (data) => ({
        url: `${API.EMPLOYEE.APPROVE_MGT_FLOAT}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["float"],
    }),
  }),
});

export const {
  useCreateEmployeeFloatMutation,
  useGetEmployeeFloatDashboardQuery,
  useGetAllloatRequestsQuery,
  useGetFloatRequestByIdQuery,
  useUpdateFloatRequestMutation,
  useApproveFloatMgtMutation,
  useDeclineFloatMgtMutation
} = employeeFloatApi;
